import { render, staticRenderFns } from "./layout-data-popup.vue?vue&type=template&id=3636e485&scoped=true"
import script from "./layout-data-popup.vue?vue&type=script&lang=js"
export * from "./layout-data-popup.vue?vue&type=script&lang=js"
import style0 from "./layout-data-popup.vue?vue&type=style&index=0&id=3636e485&prod&lang=scss&scoped=true"
import style1 from "./layout-data-popup.vue?vue&type=style&index=1&id=3636e485&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636e485",
  null
  
)

export default component.exports